import { createAction, props } from '@ngrx/store';
import { PreferenceTypes } from '@mode/shared/contract-common';

export const loadPreferences = createAction('[Preference] Load Preferences', props<{ username: string }>());

export const loadPreferencesSuccess = createAction(
  '[Preference] Load Preferences Success',
  props<{ prefs: PreferenceTypes.PreferenceState }>()
);

export const loadPreferencesFailure = createAction('[Preference] Load Preferences Failure', props<{ error: any }>());
